import type { KambiHistoryCoupon } from '@mobi/api-types/kambi'
import type { BetLoopKambiShareCoupon } from '@core/Areas/BetLoop/types'
import type { KambiSportsSelection } from '@mobi/betslip/types'
import { getKambiCouponBetType } from './getKambiCouponBetType'

type KambiCoupon = KambiHistoryCoupon | BetLoopKambiShareCoupon

export function getKambiSportsBetTypeForAnalytics(
  coupon: KambiCoupon
): `sports-${KambiSportsSelection['betSelectionType']}` {
  return `sports-${getKambiCouponBetType(coupon)}`
}

export function getSportCodeFromKambiCoupon(coupon: KambiCoupon): string | undefined {
  const events = coupon.events
  if (!events || events.length === 0) return undefined

  const firstSport = events[0].sport?.toLowerCase()
  const isMixed = events.some(event => event.sport?.toLowerCase() !== firstSport)

  if (isMixed) return 'combination'
  return firstSport || undefined
}
